module.exports = __webpack_public_path__ + "img/62.6.CODm.cac34be4.png";